module.exports = __webpack_public_path__ + "static/img/AI.91d87623.svg";